"use client";
import { ChevronsDown } from "lucide-react";
import { useGlobalContext } from "@/app/context/store";
import { useGenerator } from "@/app/context/GeneratorContext";

export default function DisplayDefault({ translations }: { translations: any }) {
  const { user } = useGlobalContext();
  const { jobHistory } = useGenerator();

  return (
    <>
      <div
        className={`px-auto flex h-[225px] w-full flex-col items-center justify-center border-[0.5px] border-[#3C3C3C] bg-[#2B2D31] text-center sm:h-[50vh] ${
          user._id !== "none" && jobHistory?.length > 0 ? "sm:rounded-b-xl" : "sm:rounded-xl"
        }`}
      >
        <h1 className="mx-5 mt-14 font-medium text-white sm:mb-auto sm:mt-auto">
          {translations.imageLoadingState0}
        </h1>
        <div className="mb-5 mt-auto sm:mt-0">
          <ChevronsDown color="white" className="mx-auto h-8 w-auto" />
          <div className="text-sm text-white">{translations.scroll}</div>
        </div>
      </div>
    </>
  );
}
